import React from "react";
import { Modal, Button, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./GeoVpnError.css";

const GeoVpnError = ({ show, onClose }) => {
  const state = useSelector((state) => state);
  const isVpn = state?.auth?.vpnResponse || false;

  const getErrorMessage = () => {
    if (isVpn) {
      return {
        title: "VPN/Proxy Detected",
        message: "To proceed, disable the proxy service on your device. Once you have resolved this error, please try again.",
        icon: "🚫"
      };
    } else {
      return {
        title: "Geolocation Restriction",
        message: "It appears that you are currently located outside of our permitted gaming area. Unfortunately, this means you are unable to access our games at this time.",
        icon: "🌍"
      };
    }
  };

  const errorInfo = getErrorMessage();

  return (
    <Modal
      size="md"
      aria-labelledby="geo-vpn-error-modal"
      centered
      backdrop="static"
      keyboard={false}
      show={show}
      className="geo-vpn-error-modal"
    >
      <Modal.Body className="text-center">
        <h4 className="geo-vpn-error-title">
          {errorInfo.title}
        </h4>
        <p className="geo-vpn-error-message">
          {errorInfo.message}
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center" style={{ border: "none" }}>
        <Col lg="8" xs="10">
          <Button
            variant="primary"
            onClick={onClose}
            className="geo-vpn-error-button w-100"
          >
            Close
          </Button>
        </Col>
      </Modal.Footer>
    </Modal>
  );
};

export default GeoVpnError;